import React from 'react'
import { DonationFormBLockClassNames } from './productFormBlock.state'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { expandableBlockClasses } from '../expandableBlock/expandableBlock.layout'
import { SharingLayout } from '../../../header/pageHeader/sharing.layout'
import { ReadSpeaker } from '../../../../readspeaker/readspeaker.widget'
import { State, renderReadSpeaker } from '../../../cmsPage.widget'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'
import { htmlDecode } from '../../../utils/html'

export const productFormBlockClasses: DonationFormBLockClassNames = {
  // DEFAULTS
  block: 'block block--donation',
  inview: 'inview',
}

export const ProductFormBlockLayout = {
  Container: (props: { children: React.ReactNode }) =>
    <div className="block__inner ls-container--l">
      <div className="block__layout">
        {props.children}
      </div>
    </div>,
  Wrapper: (p: { children: React.ReactNode, state: State }) =>
    <div className='block__wrap'>
      <SharingLayout.Wrap>
        {renderReadSpeaker(p.state) == true && <ReadSpeaker keyId="a1" encodedUrl={encodeURI(window.location.href)} readElementId={'a11y-main'} />}
        <SharingLayout.Button />
        <SharingLayout.Popup />
      </SharingLayout.Wrap>

      {p.children}
    </div>,
  Content: (p: {
    children: React.ReactNode
    text: string
  }) =>
    <section className={getClassNameModern(expandableBlockClasses, "block") + " " + getClassNameModern(expandableBlockClasses, "inview")}>
      <div className={getClassNameModern(expandableBlockClasses, "inner")}>
        <header className={getClassNameModern(expandableBlockClasses, "header")}>
          <p className={getClassNameModern(expandableBlockClasses, "intro")} dangerouslySetInnerHTML={{ __html: p.text }} />
        </header>
        <div className={getClassNameModern(expandableBlockClasses, "content")}>
          {p.children}
        </div>
      </div>
    </section>,
  Form: (p: {
    children: React.ReactNode
    showHeader?: boolean
    title: string
  }) =>
    <div className='donation ls-container ls-gutter ls-spacing'>
      <div className='donation__inner'>
        <div className='donation__form'>
          {p.showHeader && <h2 id={slugify(htmlDecode(p.title))} className='donation__title title--m'>{p.title}</h2>}
          {p.children}
        </div>
      </div>
    </div>
}
